import { CommonModule } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { AssignedCommercial } from '@core/models/assigned-commercial.model';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { DrawerModule } from 'primeng/drawer';

@Component({
  selector: 'app-commercial-drawer',
  standalone: true,
  imports: [CommonModule, DrawerModule, DividerModule, ButtonModule, AvatarModule],
  template: `
    <p-drawer
      [header]="header()"
      [(visible)]="visible"
      position="right"
      styleClass="layout-commercial-drawer !w-full sm:!w-[24rem]"
    >
      @if (commercial()) {
        <div class="flex flex-col items-center text-center">
          <!-- Photo or Avatar -->
          <div class="mb-4">
            @if (commercial()!.photo_url) {
              <img
                [src]="commercial()!.photo_url"
                [alt]="commercial()!.full_name"
                class="w-24 h-24 rounded-full object-cover border-4 border-primary shadow-lg"
              />
            } @else {
              <p-avatar
                [label]="getInitials()"
                size="xlarge"
                shape="circle"
                styleClass="!w-24 !h-24 !text-3xl bg-primary text-white"
              />
            }
          </div>

          <!-- Name -->
          <h2 class="text-xl font-semibold text-surface-900 dark:text-surface-0 mb-1">
            {{ commercial()!.full_name }}
          </h2>

          <!-- Email -->
          <p class="text-sm text-surface-600 dark:text-surface-400 mb-6">
            {{ commercial()!.email }}
          </p>

          <p-divider class="!w-full !my-4" />

          <!-- Contact Buttons -->
          <div class="flex flex-col gap-3 w-full px-4">
            <!-- WhatsApp -->
            @if (commercial()!.whatsapp_link) {
              <a
                [href]="commercial()!.whatsapp_link"
                target="_blank"
                rel="noopener noreferrer"
                class="no-underline"
              >
                <button
                  pButton
                  label="Contactar por WhatsApp"
                  icon="pi pi-whatsapp"
                  severity="success"
                  class="!w-full"
                  type="button"
                ></button>
              </a>
            }

            <!-- Email -->
            <a [href]="'mailto:' + commercial()!.email" class="no-underline">
              <button
                pButton
                label="Enviar correo"
                icon="pi pi-envelope"
                severity="secondary"
                class="!w-full"
                type="button"
              ></button>
            </a>
          </div>

          <p-divider class="!w-full !my-6" />

          <!-- Additional Info -->
          <div class="w-full px-4 text-left">
            <h3 class="text-sm font-medium text-surface-600 dark:text-surface-400 mb-3">
              Información de contacto
            </h3>

            @if (commercial()!.phones && commercial()!.phones.length > 0) {
              <div class="flex items-center gap-3 mb-3">
                <i class="pi pi-phone text-surface-500 dark:text-surface-400"></i>
                <span class="text-surface-700 dark:text-surface-300">
                  {{ commercial()!.phones[0].formatted_phone_number }}
                </span>
              </div>
            }

            <div class="flex items-center gap-3">
              <i class="pi pi-envelope text-surface-500 dark:text-surface-400"></i>
              <span class="text-surface-700 dark:text-surface-300 break-all">
                {{ commercial()!.email }}
              </span>
            </div>
          </div>
        </div>
      } @else {
        <div class="flex flex-col items-center justify-center h-full text-center">
          <i class="pi pi-user text-4xl text-surface-400 dark:text-surface-500 mb-4"></i>
          <p class="text-surface-600 dark:text-surface-400">
            No hay información del comercial disponible
          </p>
        </div>
      }
    </p-drawer>
  `,
})
export class CommercialDrawerComponent {
  visible = model<boolean>(false);
  commercial = input<AssignedCommercial | null>(null);
  header = input<string>('Tu comercial asignado');

  getInitials(): string {
    const comm = this.commercial();
    if (!comm) return '?';
    const first = comm.first_name?.charAt(0) || '';
    const last = comm.last_name?.charAt(0) || '';
    return (first + last).toUpperCase();
  }
}
